module.exports = __webpack_public_path__ + "static/008136-b837855165cc587f507bfecd24783ede.jpg";